var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-principal'),(_vm.accessApp)?_c('div',[(_vm.getHeader)?_c('div',{class:[
                    'page-wrapper', 
                    {show: _vm.showAside}, 
                    {'asideSites-active':_vm.maquetador}
                ]},[_c('router-view')],1):_vm._e()]):_vm._e(),(_vm.loading)?_c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"op-loading"})]):_vm._e(),_c('footer-principal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }